import { type JSX, splitProps } from "solid-js";
import { formatString } from "~/util/format";

interface BuisProps extends Omit<JSX.HTMLAttributes<HTMLDivElement>, "innerHTML"> {
	value?: string;
}

export function Buis(props: BuisProps) {
	const [local, others] = splitProps(props, ["value"]);
	return (
		<div
			innerHTML={formatString(local.value)}
			{...others}
		/>
	);
}
